module.exports = __webpack_public_path__ + "img/label-bb2.da2ff53e.png";